/*
  Request Account form — native submission to Shopify /contact.

  Delivery, spam protection, and the captcha all belong to Shopify: the form
  is a real {% form 'contact' %}, so the storefront captcha machinery attaches
  its token to the native POST. On success Shopify redirects back with
  ?contact_posted=true and the section's inline script forwards the applicant
  to /pages/application-received. This file only manages the submit button UX.
  (An earlier fetch()-based flow could claim success on Shopify's captcha page
  and silently lose applications — do not reintroduce it.)
*/
(function () {
  "use strict";

  function init() {
    const form = document.getElementById("RequestAccountForm");
    if (!form) return;

    const submitBtn = form.querySelector("[data-request-account-submit]");
    if (!submitBtn) return;

    form.addEventListener("submit", function () {
      // Not preventDefault — the browser performs the real submission.
      submitBtn.setAttribute("data-original-text", submitBtn.textContent);
      submitBtn.textContent = "Submitting\u2026";
      // Disable AFTER the current task so the button's value (if any) and the
      // submission proceed unaffected.
      setTimeout(function () {
        submitBtn.disabled = true;
      }, 0);
    });

    // Back/forward cache restores the page mid-"Submitting…" — reset it.
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) {
        submitBtn.disabled = false;
        var d = submitBtn.getAttribute("data-original-text");
        if (d) submitBtn.textContent = d;
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
